import React from 'react';
import styled from 'styled-components';

const TermsWrapper = styled.div`
  max-width: 900px;
  margin: 100px auto;
  padding: 40px 30px;
  background-color: #fdfdfd;
  border-radius: 16px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #222;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  color: #1a1a1a;
  margin-bottom: 20px;
`;

const Subtitle = styled.h2`
  font-size: 22px;
  margin-top: 30px;
  margin-bottom: 10px;
  color: #2e2e2e;
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 16px;
  color: #444;
`;

const List = styled.ul`
  padding-left: 25px;
  margin-bottom: 20px;

  li {
    font-size: 16px;
    line-height: 1.7;
    color: #444;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: '✔';
      color: #4caf50;
      position: absolute;
      left: -25px;
    }
  }
`;

const TermsAndConditions = () => {
  return (
    <TermsWrapper>
      <Title>Terms and Conditions</Title>

      <Paragraph>
        Welcome to Circuitech. By accessing and using our website, services, and solutions, you agree to be bound by the following terms and conditions. Please read them carefully.
      </Paragraph>

      <Subtitle>1. General Information</Subtitle>
      <Paragraph>
        These terms govern the use of our digital platforms and services. By using our website, you acknowledge that you are legally bound by these terms.
      </Paragraph>

      <Subtitle>2. Intellectual Property</Subtitle>
      <Paragraph>
        All content, trademarks, logos, designs, and media are owned by or licensed to Circuitech. Unauthorized use is strictly prohibited.
      </Paragraph>

      <Subtitle>3. Use of Services</Subtitle>
      <List>
        <li>You must not misuse or interfere with our services.</li>
        <li>You agree not to use our platform for any illegal or unauthorized purpose.</li>
        <li>We reserve the right to suspend or terminate your access if you violate these terms.</li>
      </List>

      <Subtitle>4. Limitation of Liability</Subtitle>
      <Paragraph>
        Circuitech is not liable for any damages resulting from the use or inability to use the services or content.
      </Paragraph>

      <Subtitle>5. Governing Law</Subtitle>
      <Paragraph>
        These terms shall be governed and interpreted in accordance with the laws of the United Arab Emirates.
      </Paragraph>

      <Paragraph>
        For any queries regarding our Terms and Conditions, please connect with us directly through our contact page.
      </Paragraph>
    </TermsWrapper>
  );
};

export default TermsAndConditions;
